import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CmsNavigationComponent, TranslatePipe } from '@spartacus/core';
import { LaunchDialogService, NavigationNode, IconComponent, GenericLinkComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-responsive-category-navigation',
    templateUrl: './kn-br-responsive-category-navigation.component.html',
    styleUrls: ['./kn-br-responsive-category-navigation.component.scss'],
    imports: [IconComponent, NgTemplateOutlet, GenericLinkComponent, AsyncPipe, TranslatePipe]
})
export class KnBrResponsiveCategoryNavigationComponent {
  node$: Observable<NavigationNode>;
  data$: Observable<CmsNavigationComponent>;
  constructor(protected modalService: NgbModal) {}

  dismissModal(reason?: any): void {
    this.modalService.dismissAll(reason);
  }
}
